import React from 'react';
import PropTypes from 'prop-types';
import { getTranslations } from '@translations';
import { PromosPropType } from '@propTypes';
import Button from '../Button';

import styles from './styles/index.module.scss';

const Promo = ({ isB2B, promos, onPromoClick }) => {
  const translations = getTranslations();

  return (
    <div
      className={`${styles.promoContainer} gtm-privateSaleMenu`}
      data-qa="promosLayover"
    >
      <h2 className={styles.promoTitle}>
        {translations('header.menu.dropdown.promo.title')}
      </h2>
      <ul className={styles.promoContent}>
        {promos.map(
          ({
            campaign_uuid: id,
            redirection_url: url,
            creative_desktop: desktop = {},
            creative_mobile: mobile = {},
            name,
          }) => (
            <li key={id} className={styles.promo}>
              <a
                href={url}
                className={styles.promoLink}
                data-privatesale-id={id}
                data-privatesale-name={name}
                onClick={() => onPromoClick(id, name)}
              >
                <picture>
                  <source media="(max-width: 768px)" srcSet={mobile.url} />
                  <img
                    className={styles.promoImage}
                    src={desktop.url}
                    height={280}
                    width={280}
                    alt={name}
                  />
                </picture>
                <span className={styles.promoOverlay}>
                  <span className={styles.promoOverlayAnimate}>
                    <Button tag="span" color={isB2B ? 'secondary' : 'primary'}>
                      {translations(
                        'header.menu.dropdown.promo.overlay.button',
                      )}
                    </Button>
                  </span>
                </span>
              </a>
            </li>
          ),
        )}
      </ul>
    </div>
  );
};

Promo.propTypes = {
  isB2B: PropTypes.bool.isRequired,
  promos: PromosPropType.isRequired,
  onPromoClick: PropTypes.func,
};

Promo.defaultProps = {
  onPromoClick: () => {},
};

export default Promo;
